module.exports = __webpack_public_path__ + "static/media/login_background.4cc8258c.png";